import { render, staticRenderFns } from "./AdminToolsMenu.vue?vue&type=template&id=181d64e6&scoped=true"
import script from "./AdminToolsMenu.vue?vue&type=script&lang=js"
export * from "./AdminToolsMenu.vue?vue&type=script&lang=js"
import style0 from "./AdminToolsMenu.vue?vue&type=style&index=0&id=181d64e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d64e6",
  null
  
)

export default component.exports